/**
 * Routes for Enterprise Module
 */
import React from 'react';
import { Route } from 'react-router-dom';
import Permission from 'spark-util/Permission';
import loadableModule from 'spark-views/main/loadableModule';
import { paths } from './enterpriseRoutes';

const EnterpriseManagement = loadableModule(() =>
    import(/* webpackChunkName: "enterprise" */ './index')
);

const EnterpriseRoute = () => (
    <Permission requires="em.enterpriseModule">
        <Route path={paths.root} component={EnterpriseManagement} />
    </Permission>
);

export default EnterpriseRoute;
